window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.TextSamplesSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// JetBrain
	this.os30 = new cjs.Text("Font ", "30px 'JetBrains Mono'", "#0000FF");
	this.os30.name = "os30";
	this.os30.lineHeight = 40;
	this.os30.lineWidth = 93;
	this.os30.parent = this;
	this.os30.setTransform(97.1453,91.35);
ranj.TextOffsetFixer.fix(this.os30);

	this.timeline.addTween(cjs.Tween.get(this.os30).wait(1));

	// JetBrain1
	this.os90 = new cjs.Text("Font", "90px 'JetBrains Mono'", "#00FF00");
	this.os90.name = "os90";
	this.os90.lineHeight = 119;
	this.os90.lineWidth = 308;
	this.os90.parent = this;
	this.os90.setTransform(91.4,73.9);
ranj.TextOffsetFixer.fix(this.os90);

	this.timeline.addTween(cjs.Tween.get(this.os90).wait(1));

	// JetBrain2
	this.os60 = new cjs.Text("Font ", "60px 'JetBrains Mono'");
	this.os60.name = "os60";
	this.os60.lineHeight = 79;
	this.os60.lineWidth = 282;
	this.os60.parent = this;
	this.os60.setTransform(94.3453,82.6);
ranj.TextOffsetFixer.fix(this.os60);

	this.timeline.addTween(cjs.Tween.get(this.os60).wait(1));

	// JetBrain3
	this.os120 = new cjs.Text("Font", "120px 'JetBrains Mono'", "#FF0000");
	this.os120.name = "os120";
	this.os120.lineHeight = 158;
	this.os120.lineWidth = 353;
	this.os120.parent = this;
	this.os120.setTransform(88.65,65.25);
ranj.TextOffsetFixer.fix(this.os120);

	this.timeline.addTween(cjs.Tween.get(this.os120).wait(1));

	// JetBrain4
	this.os150 = new cjs.Text("Font", "150px 'JetBrains Mono'", "#FF00FF");
	this.os150.name = "os150";
	this.os150.lineHeight = 198;
	this.os150.lineWidth = 453;
	this.os150.parent = this;
	this.os150.setTransform(85.75,56.5);
ranj.TextOffsetFixer.fix(this.os150);

	this.timeline.addTween(cjs.Tween.get(this.os150).wait(1));

	// Adam
	this.os90_1 = new cjs.Text("Font", "90px 'Adam Bold'", "#00FF00");
	this.os90_1.name = "os90_1";
	this.os90_1.lineHeight = 88;
	this.os90_1.lineWidth = 308;
	this.os90_1.parent = this;
	this.os90_1.setTransform(91,91.9);
ranj.TextOffsetFixer.fix(this.os90_1);

	this.timeline.addTween(cjs.Tween.get(this.os90_1).wait(1));

	// Adam1
	this.os30_1 = new cjs.Text("Font ", "30px 'Adam Bold'", "#0000FF");
	this.os30_1.name = "os30_1";
	this.os30_1.lineHeight = 29;
	this.os30_1.lineWidth = 93;
	this.os30_1.parent = this;
	this.os30_1.setTransform(97.0953,97.3);
ranj.TextOffsetFixer.fix(this.os30_1);

	this.timeline.addTween(cjs.Tween.get(this.os30_1).wait(1));

	// Adam2
	this.os60_1 = new cjs.Text("Font ", "60px 'Adam Bold'");
	this.os60_1.name = "os60_1";
	this.os60_1.lineHeight = 59;
	this.os60_1.lineWidth = 282;
	this.os60_1.parent = this;
	this.os60_1.setTransform(94.0453,94.6);
ranj.TextOffsetFixer.fix(this.os60_1);

	this.timeline.addTween(cjs.Tween.get(this.os60_1).wait(1));

	// Adam3
	this.os120_1 = new cjs.Text("Font", "120px 'Adam Bold'", "#FF0000");
	this.os120_1.name = "os120_1";
	this.os120_1.lineHeight = 118;
	this.os120_1.lineWidth = 353;
	this.os120_1.parent = this;
	this.os120_1.setTransform(87.95,89.3);
ranj.TextOffsetFixer.fix(this.os120_1);

	this.timeline.addTween(cjs.Tween.get(this.os120_1).wait(1));

	// Adam4
	this.os150_1 = new cjs.Text("Font", "150px 'Adam Bold'", "#FF00FF");
	this.os150_1.name = "os150_1";
	this.os150_1.lineHeight = 147;
	this.os150_1.lineWidth = 453;
	this.os150_1.parent = this;
	this.os150_1.setTransform(85.05,86.55);
ranj.TextOffsetFixer.fix(this.os150_1);

	this.timeline.addTween(cjs.Tween.get(this.os150_1).wait(1));

	// guide 
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0000FF").ss(1,1,1,3,true).p("AD6AAInzAA");
	this.shape.setTransform(125,100);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#0000FF").ss(1,1,1,3,true).p("AD6AAIAAH0AD6AAInzAAAD6nzIAAHz");
	this.shape_1.setTransform(75,100);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TextSamplesSkin, new cjs.Rectangle(49,49,1293.4,863.2), null);


// stage content:
(lib.TextPositioningAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TextSamplesSkin
	this.instance = new lib.TextSamplesSkin();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(1010,590,-469.70000000000005,-105.39999999999998);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#999999",
	opacity: 1.00,
	manifest: [],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.TextPositioningAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.TextPositioningAssets;